import * as Yup from 'yup';

export const signInSchema = Yup.object().shape({
    useCognito: Yup.boolean().default(false),
    username: Yup.string().email().max(128).required(),
    password: Yup.string()
        .max(128)
        .when('useCognito', {
            is: true,
            then: schema => schema.required(),
        }),
    rememberMe: Yup.boolean().nullable(),
});
